import {
  clearProfile,
  getProfile,
  getProfileActiveTickets,
  getProfileActiveTravelPasses,
  getProfileBookings,
  getProfileHistoryTickets,
  getProfileHistoryTravelPasses,
} from '@/features/profile/profileActions';
import type { CustomerProfileDetailsResponseDTO } from '@/types/dto/agent';
import type { BookingsState } from '@/types/profile';
import { createReducer } from '@reduxjs/toolkit';

export interface ProfileState {
  current: CustomerProfileDetailsResponseDTO | null;
  bookings: BookingsState | null;
}

const initialState: ProfileState = {
  current: null,
  bookings: null,
};

export const profileReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getProfile.fulfilled, (state, action) => {
      state.current = action.payload;
    })
    .addCase(clearProfile, (state) => {
      state.current = null;
      state.bookings = null;
    })
    .addCase(getProfileBookings.fulfilled, (state, action) => {
      state.bookings = action.payload;
    })
    .addCase(getProfileActiveTickets.fulfilled, (state, action) => {
      if (!state.bookings) {
        return;
      }

      state.bookings.tickets.active = {
        data: [...state.bookings.tickets.active.data, ...action.payload.data],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileHistoryTickets.fulfilled, (state, action) => {
      if (!state.bookings) {
        return;
      }

      state.bookings.tickets.history = {
        data: [...state.bookings.tickets.history.data, ...action.payload.data],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileActiveTravelPasses.fulfilled, (state, action) => {
      if (!state.bookings) {
        return;
      }

      state.bookings.travelPasses.active = {
        data: [
          ...state.bookings.travelPasses.active.data,
          ...action.payload.data,
        ],
        totalCount: action.payload.totalCount,
      };
    })
    .addCase(getProfileHistoryTravelPasses.fulfilled, (state, action) => {
      if (!state.bookings) {
        return;
      }

      state.bookings.travelPasses.history = {
        data: [
          ...state.bookings.travelPasses.history.data,
          ...action.payload.data,
        ],
        totalCount: action.payload.totalCount,
      };
    });
});
